/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Bot_Does_6Inputs */

const en_bot_does_6 = /** @type {(inputs: Bot_Does_6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Government sites are read in light mode: at most 3 pages, at least 3 seconds apart, no browser.`)
};

const id_bot_does_6 = /** @type {(inputs: Bot_Does_6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Situs pemerintah dibaca dalam mode ringan: maksimal 3 halaman, jeda minimal 3 detik, tanpa browser.`)
};

/**
* | output |
* | --- |
* | "Government sites are read in light mode: at most 3 pages, at least 3 seconds apart, no browser." |
*
* @param {Bot_Does_6Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const bot_does_6 = /** @type {((inputs?: Bot_Does_6Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bot_Does_6Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_bot_does_6(inputs)
	return en_bot_does_6(inputs)
});